import axios from "@/axios.js"
import http from "axios"

export default {
  getTaskList() {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/convert_question_image_to_text/question_list")
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data.data)
            return
          }
          throw new Error("Invalid response");
        })
        .catch((error) => {
          if (error.message === "Invalid response") {
            alert("서버 응답이 올바르지 않습니다. 관리자에게 문의해주세요.");
          } else {
            alert("데이터를 가져오는 데 실패했습니다.");
          }
          throw error
        })

    })
  },
  getCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var path = payload.curriculum_year == 2022 ? "category_2022" : "category/-1"
      axios.get("/api/v2/subject/" + path)
        .then((response) => {
          console.log(response.data)
          if (response.data.result == 'success') {
            commit('SET_CATEGORY_LIST', response.data.data_list)
            resolve(response)
            return
          }
          throw new Error("Invalid response");
        })
        .catch((error) => {
          if (error.message === "Invalid response") {
            alert("서버 응답이 올바르지 않습니다. 관리자에게 문의해주세요.");
          } else {
            alert("데이터를 가져오는 데 실패했습니다.");
          }
          throw error
        })

    })
  },
  getMainCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var pathParameter = payload.curriculum_year == 2022 ? 'main_category_2022?category_id=' + payload.category_id : 'main-category?id=' + payload.category_id
      axios.get("/api/v2/subject/" + pathParameter)
        .then((response) => {
          if (response.data.result == 'success') {
            // console.log(response.data.data)
            commit('SET_MAIN_CATEGORY_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSubCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var pathParameter = payload.curriculum_year == 2022 ? 'sub_category_2022?main_category_id=' + payload.main_category_id : 'sub-category?id=' + payload.main_category_id
      axios.get("/api/v2/subject/" + pathParameter)
        .then((response) => {
          if (response.data.result == 'success') {
            // console.log(response.data.data)
            commit('SET_SUB_CATEGORY_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 출판사 리스트
  getPublisherList({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/exam/publisher')
        .then((res) => {
          commit('SET_PUBLISHER_LIST', res.data.data_list)
          resolve(res)
        })
        .catch(reject)
    })
  },

  // 책분류 리스트
  getTextbookPublisherList({ commit }, publisherId) {
    console.log(publisherId)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/exam/textbook_publisher/all?publisher_id=${publisherId}`)
        .then((res) => {
          commit('SET_TEXTBOOK_PUBLISHER_LIST', res.data.data_list)
          resolve(res)
        })
        .catch(reject)
    })
  },

  // 교과서 리스트
  getTextbookSubjectList({ commit }, textbookId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/exam/textbook_subject?textbook_id=${textbookId}`)
        .then((res) => {
          const filtered = (res.data.data_list || []).filter(
            (item) => item.subject_type_id === 1 || item.subject_type_id === 2
          )
          commit('SET_TEXTBOOK_SUBJECT_LIST', filtered)
          resolve(filtered)
        })
        .catch(reject)
    })
  },



  // 대중소 목차 리스트
  async getTextbookContentList({ commit }, subjectId) {
    try {
      const [content, main, sub] = await Promise.all([
        axios.get(`/api/v2/exam/textbook_content_subject?subject_id=${subjectId}`),
        axios.get(`/api/v2/exam/textbook_content_main_subject?subject_id=${subjectId}`),
        axios.get(`/api/v2/exam/textbook_content_sub_subject?subject_id=${subjectId}`)
      ])

      const data = {
        content: content.data.data_list,
        main: main.data.data_list,
        sub: sub.data.data_list,
      }

      console.log(data)
      return data

    } catch (error) {
      console.log(error)
      throw error
    }
  },
  getCategoryQuestionList(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v2/exam/question_list/category_info", { params: payload })
        .then((response) => {
          if (response.data.result === "success") {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  getContentQuestionList(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v2/exam/question_list/content_info", { params: payload })
        .then((response) => {
          if (response.data.result === "success") {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  // 작업 카드 클릭 시 문제 리스트 호출
  getWorkQuestionList(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v2/exam/convert_question_image_to_text/question_list/detail", { params: payload })
        .then((response) => {
          if (response.data.result === "success") {
            console.log(response.data)
            resolve(response.data.data.question_list || [])
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  // 문제의 잘라둔 이미지 데이터 가져오기 (ZIP ArrayBuffer 반환)
  getQuestionPngImages(context, questionId) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v2/exam/convert_question_image_to_text/question/png", {
          params: { question_id: questionId },
          responseType: 'arraybuffer',
        })
        .then((response) => {
          // ZIP 바이너리 그대로 반환 (상위에서 JSZip 등으로 파싱)
          resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
  // 문제 텍스트 변환 작업 보류 처리
  setQuestionPending(context, payload) {
    // payload: { question_id: number }
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/exam/convert_question_image_to_text/pending', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  uploadCroppedImages({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/exam/convert_question_image_to_text', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') resolve(response)
          else reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  // 유형정보 전체 가져오기 (대유형/중유형/소유형 한번에)
  getCategoryTreeList(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v2/exam/convert_question_image_to_text/category_list', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            const data = response.data.data || []
            resolve(data)
            return
          }
          reject(new Error('API 응답이 success가 아닙니다: ' + (response.data.result || 'unknown')))
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 목차정보 전체 가져오기 (대목차/중목차/소목차 한번에)
  getContentTreeList(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v2/exam/convert_question_image_to_text/content_list', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            const data = response.data.data || []
            resolve(data)
            return
          }
          reject(new Error('API 응답이 success가 아닙니다: ' + (response.data.result || 'unknown')))
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 문제 이미지를 텍스트로 변환 시작
  convertQuestionImageToText(context, payload) {
    // payload: { question_id: number }
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/exam/convert_question_image_to_text', { question_id: payload.question_id })
        .then((response) => {
          // 처리하는 방식이 변경되어 리턴값 받는 시간이 오래 걸려 임시처리리
          resolve(response)
          // if (response.data.result === 'success') {
          //   resolve(response)
          // } else {
          //   reject(response)
          // }
        })
        .catch((error) => reject(error))
    })
  },
  // 문제 결과 데이터 가져오기 (텍스트화된 결과 포함)
  getQuestionResult(context, questionId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v2/exam/question/${questionId}`)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data.data)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  // 텍스트화 결과 수정 (수정한 영역 데이터만 전달)
  // payload: { question_id, title_text?, sequence_text?, question_multiple_list?: [{ id, choice_text }] }
  updateImageToText(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/exam/question/image_to_text', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  // 승인 (완료 처리)
doneQuestion(context, payload) {
  // payload: { question_id: number, has_image?: boolean }
  return new Promise((resolve, reject) => {
    axios
      .put('/api/v2/exam/convert_question_image_to_text/done', {
        question_id: payload.question_id,
        has_image: !!payload.has_image, 
      })
      .then((response) => {
        if (response.data.result === 'success') {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch((error) => reject(error))
  })
},
  // 문제 삭제
  deleteQuestion(context, payload) {
    // payload: { question_id: number }
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/exam/convert_question_image_to_text/delete', { question_id: payload.question_id })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  // 재작업 (restart)
  restartQuestion(context, formData) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/exam/convert_question_image_to_text/restart', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') resolve(response)
          else reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  // 사용자 작업량 정보 가져오기
  getUserInfo(context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v2/exam/convert_question_image_to_text/user_info')
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data.data)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
}